import { useState, useRef, useEffect } from "react";
import { Button } from "./Button";
import { useTranslate } from "@/providers/context";
import { cn } from "@/utils";

interface ScrollToTopButtonProps {
  scrollContainerId: string;
}

export const ScrollToTopButton = ({
  scrollContainerId,
}: ScrollToTopButtonProps) => {
  const { translate } = useTranslate();
  const [showBackToTop, setShowBackToTop] = useState(false);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const scrollContainer = document.getElementById(scrollContainerId);

    if (scrollContainer) {
      const handleScroll = () => {
        const scrollTop = scrollContainer.scrollTop;
        const passedThreshold = scrollTop > 250;
        const isScrollingUp = scrollTop < lastScrollTop.current;

        setShowBackToTop(passedThreshold && isScrollingUp);
        lastScrollTop.current = scrollTop;
      };

      scrollContainer.addEventListener("scroll", handleScroll);

      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [scrollContainerId]);

  const scrollToTop = () => {
    const scrollContainer = document.getElementById(scrollContainerId);
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        className={cn(
          "duration-250 rounded-full p-3 opacity-0 shadow-lg transition-all ease-in-out hover:scale-[1.03] active:scale-100",
          showBackToTop && "opacity-100",
        )}
        onClick={scrollToTop}
      >
        {translate("Back To Top")}
      </Button>
    </div>
  );
};
